@if (state$ | async; as state) {
  <div class="page permits">
    <h1 class="c-h1">{{ 'PERSONAL_DATA.PERMITS.title' | translate }}</h1>

    <div class="permits-intro">
      <myabvv-introduction [introduction]="'PERSONAL_DATA.PERMITS.info' | translate"></myabvv-introduction>
    </div>

    <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>

    @if (state.loading) {
      <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
    }

    @if (!state.loading && !state.error) {
      <!-- Residence Permits Section -->
      <section class="permits-section">
        <div class="permits-section__header">
          <div class="permits-section__icon">
            <i class="fa fa-id-card"></i>
          </div>
          <h2 class="permits-section__title">{{ 'PERSONAL_DATA.PERMITS.residencepermit' | translate }}</h2>
        </div>
        <myabvv-permit-residences [residencePermits]="state.data?.residencePermits"></myabvv-permit-residences>
      </section>

      <!-- Work Permits Section -->
      <section class="permits-section">
        <div class="permits-section__header">
          <div class="permits-section__icon">
            <i class="fa fa-briefcase"></i>
          </div>
          <h2 class="permits-section__title">{{ 'PERSONAL_DATA.PERMITS.workpermit' | translate }}</h2>
        </div>
        <myabvv-permit-works [workPermits]="state.data?.workPermits"></myabvv-permit-works>
      </section>

      <!-- Extra Info Note -->
      <div class="permits-note">
        <i class="fa fa-info-circle permits-note__icon"></i>
        <p class="permits-note__text">{{ 'PERSONAL_DATA.PERMITS.extra_info' | translate }}</p>
      </div>
    }
  </div>
}
